import styled from 'styled-components';
import { colors, fonts, breakpoints } from '../../theme';

export const TaglineContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  text-align: center;
`;

export const TaglineText = styled.h1`
  color: ${colors.white};
  font-family: ${fonts.families.primary};
  font-size: clamp(1.2rem, 3.5vw, 2.2rem);
  font-weight: ${fonts.weights.bold};
  text-transform: ${fonts.textTransform.uppercase};
  letter-spacing: ${fonts.letterSpacing.wide};
  text-shadow: 2px 2px 4px ${colors.blackTransparent[90]};
  margin: 0;
  white-space: nowrap;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: clamp(1rem, 3vw, 1.8rem);
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: clamp(0.9rem, 2.5vw, 1.4rem);
    letter-spacing: 0.5px;
    white-space: normal;
  }
`;

export const FirstPart = styled.span`
  font-family: ${fonts.families.secondary};
  font-weight: ${fonts.weights.normal};
`;

export const Comma = styled.span`
  color: ${colors.primary};
  font-family: ${fonts.families.secondary};
  font-weight: ${fonts.weights.normal};
`;

export const SecondPart = styled.span`
  font-family: ${fonts.families.primary};
  font-weight: ${fonts.weights.bold};
`;
